import moment from 'moment';

export const MaintenanceConfig = {
  // Configuration for maintenance window
  MAINTENANCE_DATE: '2026-08-14',
  MAINTENANCE_START_TIME: '07:00:00',
  MAINTENANCE_END_TIME: '20:00:00',

  // Function to check if banner should be shown
  shouldShowMaintenanceBanner: () => {
    // Get current time in Hong Kong timezone
    const hkDate = new Date().toLocaleString('en-US', { timeZone: 'Asia/Hong_Kong' });
    const hkDateTime = moment(hkDate, 'M/D/YYYY, h:mm:ss A').toDate();

    // Create maintenance start and end times in Hong Kong timezone
    const maintenanceStart = moment(`${MaintenanceConfig.MAINTENANCE_DATE} ${MaintenanceConfig.MAINTENANCE_START_TIME}`, 'YYYY-MM-DD HH:mm:ss').toDate();
    const maintenanceEnd = moment(`${MaintenanceConfig.MAINTENANCE_DATE} ${MaintenanceConfig.MAINTENANCE_END_TIME}`, 'YYYY-MM-DD HH:mm:ss').toDate();

    // Only show banner during the maintenance window
    return hkDateTime >= maintenanceStart && hkDateTime <= maintenanceEnd;
  }
};

export default MaintenanceConfig;
